/* ==========================================
   CATERPY FITTING SYSTEM
========================================== */

// ----------------------------
// 質問データ
// ----------------------------

const questions = [
{
    title: "あなたのヒモ靴の穴の数は？",
    answers: [
        {
            value: "5穴",
            image: "https://cdn.shopify.com/s/files/1/2589/1324/files/5ha.jpg?v=1785983450"
        },
        {
            value: "6穴",
            image: "https://cdn.shopify.com/s/files/1/2589/1324/files/6ha.jpg?v=1785983450"
        },
        {
            value: "7穴",
            image: "https://cdn.shopify.com/s/files/1/2589/1324/files/7ha.jpg?v=1785983450"
        }
    ]
},
{
    title: "足の特長",
    answers: [
        {
            value:"普通、もしくは女性・キッズ",
            image:"https://cdn.shopify.com/s/files/1/2589/1324/files/normal.jpg?v=1783673391"
        },
        {
            value:"甲が高い、もしくは甲が広い",
            image:"https://cdn.shopify.com/s/files/1/2589/1324/files/wide.jpg?v=1783673392"
        }
    ]
},
{
    title: "靴のサイズを選んでください",
    answers: [
        {
            value:"24.5cm以下",
            image:"https://cdn.shopify.com/s/files/1/2589/1324/files/shoessize1.png?v=1786070780"
        },
        {
            value:"25.0〜29.0cm",
            image:"https://cdn.shopify.com/s/files/1/2589/1324/files/shoessize2.png?v=1786070780"
        },
        {
            value:"29.5cm以上",
            image:"https://cdn.shopify.com/s/files/1/2589/1324/files/shoessize3.png?v=1786070780"
        }
    ]
}
];


// ----------------------------
// 診断結果データ
// ----------------------------
const results = {

    "5-normal-small":{
        title:"●靴の穴数：5穴\n●足の特徴：普通/女性もしく子供\n●靴のサイズ：24.5cm以下",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY JUNIOR/26コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/coming_soon.png?v=1786095207",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy?variant=68040734605501",
                video:"https://cdn.shopify.com/videos/c/o/v/5b50793579454a6391d65dc12a73f41f.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPYJr_5_-A.png?v=1787295101",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-cj42.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-cj42.jpg"
            },
            {
                subtitle: "ゆったりフィット～\n標準フィット",
                star: "★★☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 55cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca55-2-img.jpg?v=1787192570",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/6cc13dc3e91d460a9e98c5c190663898.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_5_55cm_1-5-3_04_00-01.jpg?v=1786508935",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg"
            }
        ]
    },

    "5-normal-medium":{
        title:"●靴の穴数：5穴\n●足の特徴：普通/女性もしく子供\n●靴のサイズ：25.0～29.0cm",
        products: [
            {
                subtitle: "しっかり～\n標準フィット",
                star: "★★★★☆",
                name: "結ばない靴ひも\nCATERPY 50cm/32コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c50-2-img.jpg?v=1787192570",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "スポーツでしっかりフィットさせたい\n足との一体感を重視したい\nシューズ内で足が動くのを抑えたい\nランニングやウォーキングにおすすめ\n安定したフィット感を求める方",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/bf1db6ecaaf6430591f4e7fa74c4336f.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_5_-B.png?v=1787295101",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c50_857ce10f-df6b-4d39-9ced-1da48c85a66d.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c50_857ce10f-df6b-4d39-9ced-1da48c85a66d.jpg"
            },
            {
                subtitle: "標準フィット～\nゆったりフィット",
                star: "★★☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 55cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca55-2-img.jpg?v=1787192570",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/6cc13dc3e91d460a9e98c5c190663898.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_5_55cm_1-5-3_04_00-01.jpg?v=1786508935",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg"
            }
        ]
    },

    "5-normal-large":{
        title:"●靴の穴数：5穴\n●足の特徴：普通/女性もしく子供\n●靴のサイズ：29.5cm以上",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY 75cm/49コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c75-img.jpg?v=1786093765",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/9d09c087c50d479dbb0e2f1a6d532453.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_5_-C.png?v=1787295100",
                videotxt:"※ 現在、このサイズ専用の通し方動画を準備しております。\n公開まで今しばらくお待ちください",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg"
            },
            {
                subtitle: "ゆったりフィット",
                star: "★☆☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 70cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca70-img.jpg?v=1786093769",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/e2fd104fdb444caeb20d1450943e849f.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_6_-B_70cm_01_00-00.jpg?v=1786508935",
                videotxt:"※ 現在、このサイズ専用の通し方動画を準備しております。\n公開まで今しばらくお待ちください",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg"
            }
        ]
    },

    "5-wide-small":{
        title:"●靴の穴数：5穴\n●足の特徴：甲高・幅広\n●靴のサイズ：24.5cm以下",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY JUNIOR/26コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/coming_soon.png?v=1786095207",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/collections/shoelaces",
                video:"https://cdn.shopify.com/videos/c/o/v/5b50793579454a6391d65dc12a73f41f.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPYJr_5_-A.png?v=1787295101",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-cj42.jpg?v=1787789491",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-cj42.jpg?v=1787789491"
            },
            {
                subtitle: "ゆったりフィット～\n標準フィット",
                star: "★★☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 55cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca55-2-img.jpg?v=1787192570",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/6cc13dc3e91d460a9e98c5c190663898.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_5_55cm_1-5-3_04_00-01.jpg?v=1786508935",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg"
            }
        ]
    },

    "5-wide-medium":{
        title:"●靴の穴数：5穴\n●足の特徴：甲高・幅広\n●靴のサイズ：25.0～29.0cm",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY 60cm/37コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c60-2-img.jpg?v=1787192570",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/9d09c087c50d479dbb0e2f1a6d532453.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_5_-C.png?v=1787295100",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c60_5fa2390a-95f5-474d-b394-5118f8b45740.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c60_5fa2390a-95f5-474d-b394-5118f8b45740.jpg"
            },
            {
                subtitle: "標準フィット～\nゆったりフィット",
                star: "★★☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 55cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca55-2-img.jpg?v=1787192570",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/6cc13dc3e91d460a9e98c5c190663898.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_5_55cm_1-5-3_04_00-01.jpg?v=1786508935",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg"
            }
        ]
    },

    "5-wide-large":{
        title:"●靴の穴数：5穴\n●足の特徴：甲高・幅広\n●靴のサイズ：29.5cm以上",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY 75cm/49コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c75-img.jpg?v=1786093765",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/a0bd9a510f7e4d759991e9ccbef0f362.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_6-B_03-BGM__01_00-00.jpg?v=1786508937",
                videotxt:"※ 現在、このサイズ専用の通し方動画を準備しております。\n公開まで今しばらくお待ちください",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg"
            },
            {
                subtitle: "ゆったりフィット",
                star: "★☆☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 70cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca70-img.jpg?v=1786093769",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/e2fd104fdb444caeb20d1450943e849f.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_6_-B_70cm_01_00-00.jpg?v=1786508935",
                videotxt:"※ 現在、このサイズ専用の通し方動画を準備しております。\n公開まで今しばらくお待ちください",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg"
            }
        ]
    },

    "6-normal-small":{
        title:"●靴の穴数：6穴\n●足の特徴：普通/女性もしく子供\n●靴のサイズ：24.5cm以下",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY 60cm/37コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c60-2-img.jpg?v=1787192570",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/464dfa578cef4a4c84ee0a179dd2ac52.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_6-B.png?v=1787301595",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c60_5fa2390a-95f5-474d-b394-5118f8b45740.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c60_5fa2390a-95f5-474d-b394-5118f8b45740.jpg"
            },
            {
                subtitle: "標準フィット～\nゆったりフィット",
                star: "★★☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 55cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca55-2-img.jpg?v=1787192570",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/a7be36b2e8044013a6e9d996536ca1ce.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_6_-A_55cm_01_00-00.jpg?v=1786508936",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg"
            }
        ]
    },

    "6-normal-medium":{
        title:"●靴の穴数：6穴\n●足の特徴：普通/女性もしく子供\n●靴のサイズ：25.0~29.0cm",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY 60cm/37コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c60-2-img.jpg?v=1787192570",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/464dfa578cef4a4c84ee0a179dd2ac52.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_6-B.png?v=1787301595",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c60_5fa2390a-95f5-474d-b394-5118f8b45740.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c60_5fa2390a-95f5-474d-b394-5118f8b45740.jpg"
            },
            {
                subtitle: "ゆったりフィット～\n標準フィット",
                star: "★★☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 55cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca55-2-img.jpg?v=1787192570",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/a7be36b2e8044013a6e9d996536ca1ce.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_6_-A_55cm_01_00-00.jpg?v=1786508936",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg"
            }
        ]
    },

    "6-normal-large":{
        title:"●靴の穴数：6穴\n●足の特徴：普通/女性もしく子供\n●靴のサイズ：29.5cm以上",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY 75cm/49コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c75-img.jpg?v=1786093765",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/29ffc047fe844b1c9f0277d9627df75b.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_6-C.png?v=1787301594",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg"
            },
            {
                subtitle: "ゆったりフィット",
                star: "★☆☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 70cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca70-img.jpg?v=1786093769",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/e2fd104fdb444caeb20d1450943e849f.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_6_-B_70cm_01_00-00.jpg?v=1786508935",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg"
            }
        ]
    },
    
    "6-wide-small":{
        title:"●靴の穴数：6穴\n●足の特徴：甲高・幅広\n●靴のサイズ：24.5cm以下",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY 60cm/37コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c60-2-img.jpg?v=1787192570",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/464dfa578cef4a4c84ee0a179dd2ac52.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_6-B.png?v=1787301595",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c60_5fa2390a-95f5-474d-b394-5118f8b45740.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c60_5fa2390a-95f5-474d-b394-5118f8b45740.jpg"
            },
            {
                subtitle: "標準フィット～\nゆったりフィット",
                star: "★★☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 55cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca55-2-img.jpg?v=1787192570",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/a7be36b2e8044013a6e9d996536ca1ce.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_6_-A_55cm_01_00-00.jpg?v=1786508936",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac55.jpg"
            }
        ]
    },

    "6-wide-medium":{
        title:"●靴の穴数：6穴\n●足の特徴：甲高・幅広\n●靴のサイズ：25.0~29.0cm",
        products: [
            {
                subtitle: "しっかりフィット～\n標準フィット",
                star: "★★★★☆",
                name: "結ばない靴ひも\nCATERPY 60cm/37コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c60-2-img.jpg?v=1787192570",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "スポーツでしっかりフィットさせたい\n足との一体感を重視したい\nシューズ内で足が動くのを抑えたい\nランニングやウォーキングにおすすめ\n安定したフィット感を求める方",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/464dfa578cef4a4c84ee0a179dd2ac52.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_6-B.png?v=1787301595",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c60_5fa2390a-95f5-474d-b394-5118f8b45740.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c60_5fa2390a-95f5-474d-b394-5118f8b45740.jpg"
            },
            {
                subtitle: "ゆったりフィット～\n標準フィット",
                star: "★★☆☆☆",
                name: "結ばない靴ひも\nCATERPY 75cm/49コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c75-img.jpg?v=1786093765",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/29ffc047fe844b1c9f0277d9627df75b.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_6-C.png?v=1787301594",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg"
            }
        ]
    },

    "6-wide-large":{
        title:"●靴の穴数：6穴\n●足の特徴：甲高・幅広\n●靴のサイズ：29.5cm以上",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY 75cm/49コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c75-img.jpg?v=1786093765",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/29ffc047fe844b1c9f0277d9627df75b.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_6-C.png?v=1787301594",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg"
            },
            {
                subtitle: "ゆったりフィット",
                star: "★☆☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 70cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca70-img.jpg?v=1786093769",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/e2fd104fdb444caeb20d1450943e849f.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_6_-B_70cm_01_00-00.jpg?v=1786508935",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg"
            }
        ]
    },

    "7-normal-medium":{
        title:"●靴の穴数：7穴\n●足の特徴：普通/女性もしく子供\n●靴のサイズ：25.0~29.0cm",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY 75cm/49コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c75-img.jpg?v=1786093765",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/c074d73a74024f56b836e66d17b4fcec.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_7-A.png?v=1787302536",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg"
            },
            {
                subtitle: "ゆったりフィット",
                star: "★☆☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 70cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca70-img.jpg?v=1786093769",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/0db702c8f87d4db6ab389d88490a0791.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_7_-B_70cm_01_00-00.jpg?v=1786508935",
                videotxt:"※ 現在、このサイズ専用の通し方動画を準備しております。\n公開まで今しばらくお待ちください",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg"
            }
        ]
    },

    "7-normal-large":{
        title:"●靴の穴数：7穴\n●足の特徴：普通/女性もしく子供\n●靴のサイズ：29.5cm以上",
        products: [
            {
                subtitle: "しっかりフィット",
                star: "★★★★★",
                name: "結ばない靴ひも\nCATERPY 75cm/49コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c75-img.jpg?v=1786093765",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "高いホールド感を求める\n激しい動きのスポーツをする\n足とシューズの一体感を重視したい\nシューズ内で足をしっかり固定したい\nフィット感を最優先したい",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/c074d73a74024f56b836e66d17b4fcec.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_7-A.png?v=1787302536",
                videotxt:"※ 現在、このサイズ専用の通し方動画を準備しております。\n公開まで今しばらくお待ちください",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg"
            },
            {
                subtitle: "しっかりフィット",
                star: "★★★★★",
                name: "結ばない靴ひも\nAIR CATERPY 70cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca70-img.jpg?v=1786093769",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "高いホールド感を求める\n激しい動きのスポーツをする\n足とシューズの一体感を重視したい\nシューズ内で足をしっかり固定したい\nフィット感を最優先したい",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/0db702c8f87d4db6ab389d88490a0791.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_7_-B_70cm_01_00-00.jpg?v=1786508935",
                videotxt:"※ 現在、このサイズ専用の通し方動画を準備しております。\n公開まで今しばらくお待ちください",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg"
            }
        ]
    },

    "7-wide-medium":{
        title:"●靴の穴数：7穴\n●足の特徴：甲高・幅広\n●靴のサイズ：25.0~29.0cm",
        products: [
            {
                subtitle: "標準フィット",
                star: "★★★☆☆",
                name: "結ばない靴ひも\nCATERPY 75cm/49コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c75-img.jpg?v=1786093765",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "CATERPYの標準的なフィット感を体感したい\n普段履きにもスポーツにも使いたい\nバランスの良いフィット感を求める方\n初めてCATERPYを使用する方\n迷ったらこちらがおすすめ",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/c074d73a74024f56b836e66d17b4fcec.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_7-A.png?v=1787302536",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg"
            },
            {
                subtitle: "ゆったりフィット",
                star: "★☆☆☆☆",
                name: "結ばない靴ひも\nAIR CATERPY 70cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca70-img.jpg?v=1786093769",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "脱ぎ履きしやすさを重視したい\n普段履きがメイン\n足への圧迫感を抑えたい\n長時間履くことが多い",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/0db702c8f87d4db6ab389d88490a0791.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_7_-B_70cm_01_00-00.jpg?v=1786508935",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg"
            }
        ]
    },

    "7-wide-large":{
        title:"●靴の穴数：7穴\n●足の特徴：甲高・幅広\n●靴のサイズ：29.5cm以上",
        products: [
            {
                subtitle: "しっかりフィット",
                star: "★★★★★",
                name: "結ばない靴ひも\nCATERPY 75cm/49コブ",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/c75-img.jpg?v=1786093765",
                description: "しっかりフィットさせたい方におすすめ。",
                subDescription: "高いホールド感を求める\n激しい動きのスポーツをする\n足とシューズの一体感を重視したい\nシューズ内で足をしっかり固定したい\nフィット感を最優先したい",
                url: "https://caterpy.com/products/caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/c074d73a74024f56b836e66d17b4fcec.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/CATERPY_7-A.png?v=1787302536",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-c75_c1b9366e-376d-467b-bd81-40a5ef4f44ba.jpg"
            },
            {
                subtitle: "しっかりフィット",
                star: "★★★★★",
                name: "結ばない靴ひも\nAIR CATERPY 70cm",
                image: "https://cdn.shopify.com/s/files/1/2589/1324/files/ca70-img.jpg?v=1786093769",
                description: "やわらかいフィット感を求める方におすすめ。",
                subDescription: "高いホールド感を求める\n激しい動きのスポーツをする\n足とシューズの一体感を重視したい\nシューズ内で足をしっかり固定したい\nフィット感を最優先したい",
                url: "https://caterpy.com/products/air-caterpy",
                video:"https://cdn.shopify.com/videos/c/o/v/0db702c8f87d4db6ab389d88490a0791.mp4",
                videoThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/AIR_CATERPY_7_-B_70cm_01_00-00.jpg?v=1786508935",
                videotxt:"",
                detailImage: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg",
                detailImageThumbnail: "https://cdn.shopify.com/s/files/1/2589/1324/files/himoplan-ac70.jpg"
            }
        ]
    }


};

// ----------------------------
// GA4 計測
// ----------------------------

function trackGA4(eventName, params = {}) {

    if (typeof window.gtag === "function") {

        window.gtag("event", eventName, params);

    } else {

        console.warn(
            "GA4 gtag is not available:",
            eventName,
            params
        );

    }

}
// ----------------------------
// 状態管理
// ----------------------------

let currentQuestion = 0;
let answers = [];
let currentResultKey = "";

// ----------------------------
// 要素取得
// ----------------------------

const startScreen = document.getElementById("startScreen");
const questionScreen = document.getElementById("questionScreen");
const resultScreen = document.getElementById("resultScreen");

const startButton = document.getElementById("startButton");
const nextButton = document.getElementById("nextButton");

const questionTitle = document.getElementById("questionTitle");
const answerContainer = document.getElementById("answerContainer");

const progressFill = document.getElementById("progressFill");
const progressText = document.getElementById("progressText");

const restartButton = document.getElementById("restartButton");

// ----------------------------
// 診断開始
// ----------------------------

startButton.addEventListener("click", () => {

    // GA4：診断開始
    trackGA4("caterpy_fitting_start", {
        fitting_name: "CATERPYフィッティングシステム"
    });

    startScreen.classList.remove("active");
    questionScreen.classList.add("active");

    showQuestion();

});

// ----------------------------
// 質問表示
// ----------------------------

function showQuestion(){

    nextButton.disabled = true;

    const count = questions[currentQuestion].answers.length;

    answerContainer.className = `answer-grid cols-${count}`;
    
    questionTitle.textContent =
        questions[currentQuestion].title;

    answerContainer.innerHTML = "";

    const percent =
        ((currentQuestion + 1) / questions.length) * 100;

    progressFill.style.width = percent + "%";

    progressText.textContent =
        `${currentQuestion + 1} / ${questions.length}`;

    questions[currentQuestion].answers.forEach((answer,index)=>{

        const card = document.createElement("div");

        card.className = "answer-card";

        // 7穴の場合は24.5cm以下を選択不可

        if(
            currentQuestion === 2 &&
            answers[0] === "7穴" &&
            index === 0
        ){

            card.classList.add("disabled");

        }

        card.innerHTML = `

        <img
            src="${answer.image}"
            alt="${answer.value}"
        >

        <h3>${answer.value}</h3>

        `;

        card.addEventListener("click", ()=>{

            if(card.classList.contains("disabled")){
                return;
            }

            document
                .querySelectorAll(".answer-card")
                .forEach(el=>el.classList.remove("selected"));

            card.classList.add("selected");

            answers[currentQuestion]=answer.value;

            nextButton.disabled = false;

        });

        answerContainer.appendChild(card);

    });

}

// ----------------------------
// 次へ
// ----------------------------

nextButton.addEventListener("click",()=>{

    // GA4：質問への回答
    trackGA4("caterpy_fitting_answer", {

        question_number: currentQuestion + 1,

        question_name:
            questions[currentQuestion].title,

        answer_value:
            answers[currentQuestion] || ""

    });

    currentQuestion++;

    if(currentQuestion < questions.length){

        showQuestion();

    }else{

        finishDiagnosis();

    }

});

// ----------------------------
// 完了
// ----------------------------

function finishDiagnosis() {

    // 質問画面を非表示
    questionScreen.classList.remove("active");

    // 結果画面を表示
    resultScreen.classList.add("active");


    // ----------------------------
    // 診断結果キーを作成
    // ----------------------------

    const key = createResultKey();

    console.log("診断結果キー:", key);

    const result = results[key];

    // 現在の診断結果キーを保存
    currentResultKey = key;


    // ----------------------------
    // 診断結果が存在しない場合
    // ----------------------------

    if (!result) {

        document.getElementById("resultName").textContent =
            "診断結果が見つかりません";

        console.error("診断結果がありません:", key);

        return;
    }

    // ----------------------------
    // GA4：診断完了
    // ----------------------------
    trackGA4("caterpy_fitting_complete", {

        hole_count:
            answers[0] || "",

        foot_type:
            answers[1] || "",

        shoe_size:
            answers[2] || "",

        result_key:
            key

    });

    // ----------------------------
    // タイトル
    // ----------------------------

    document.getElementById("resultName").textContent =
        result.title || "";


    // ----------------------------
    // 説明文
    // ----------------------------

 //     document.getElementById("resultDescription").textContent =
 //         result.description || "";


    // ----------------------------
    // 通し方画像
    // ----------------------------

//     const himoImage =
//         document.getElementById("resulthimoImage");
// 
//     if (result.himoimage) {
// 
//         himoImage.src = result.himoimage;
//         himoImage.style.display = "block";
// 
//     } else {
// 
//         himoImage.removeAttribute("src");
//         himoImage.style.display = "none";
// 
//     }




    // ----------------------------
    // おすすめ商品
    // ----------------------------

    const productContainer =
        document.getElementById("resultProducts");

    // 前回の商品を削除
    productContainer.innerHTML = "";


    // productsが存在する場合
    if (
        result.products &&
        result.products.length > 0
    ) {

        result.products.forEach(product => {

            const productCard =
                document.createElement("div");

            productCard.className =
                "result-product";


            productCard.innerHTML = `

                <h4 class="result-product-subtitle">
                    ${product.subtitle || ""}
                </h4>

                <img
                    src="${product.image}"
                    alt="${product.name}"
                    class="result-product-image"
                >

                <h4 class="result-product-name">
                    ${product.name.replace(/\n/g, "<br>")}
                </h4>


                ${
                    product.detailImage && product.detailImageThumbnail
                    ?
                    `
                    <button
                        type="button"
                        class="product-image-trigger"
                        data-image="${product.detailImage}"
                        data-title="${product.name.replace(/\n/g, " ")} 詳細画像"
                    >
                        <img
                            src="${product.detailImageThumbnail}"
                            alt="${product.name.replace(/\n/g, " ")} 詳細画像"
                            class="product-detail-thumbnail"
                        >

                        <span class="product-image-label">
                            図面を見る
                        </span>
                    </button>
                    `
                    :
                    ""
                }


                ${
                    product.description
                    ?
                    `
                    <p class="result-product-description">
                        ${product.description.replace(/\n/g, "<br>")}
                    </p>
                    `
                    :
                    ""
                }

                ${
                    product.subDescription
                    ?
                    `
                    <p class="result-product-subdescription">
                        ${product.subDescription.replace(/\n/g, "<br>")}
                    </p>
                    `
                    :
                    ""
                }

                <a
                    href="${product.url}"
                    class="caterpy-btn result-product-btn"
                    data-product-name="${product.name.replace(/\n/g, " ")}"
                >
                    このCATERPYを選ぶ
                </a>

                ${
                    product.video && product.videoThumbnail
                    ?
                    `
                    <button
                        type="button"
                        class="product-video-trigger"
                        data-video="${product.video}"
                        data-title="${product.name} 通し方動画"
                        data-product-name="${product.name.replace(/\n/g, " ")}"
                    >

                        <img
                            src="${product.videoThumbnail}"
                            alt="${product.name} 通し方動画"
                            class="product-video-thumbnail"
                        >

                        <span class="product-video-play">
                            ▶
                        </span>

                        <span class="product-video-label">
                            通し方動画を見る
                        </span>

                    </button>
                    `
                    :
                    ""
                }


                ${
                    product.videotxt
                    ?
                    `
                    <p class="result-product-videotxt">
                        ${product.videotxt.replace(/\n/g, "<br>")}
                    </p>
                    `
                    :
                    ""
                }
            `;

            productContainer.appendChild(productCard);

        });




    } else {

        productContainer.innerHTML =
            "<p>おすすめ商品が設定されていません。</p>";

    }


    // ----------------------------
    // 結果画面の先頭へ移動
    // ----------------------------

    resultScreen.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });

}

// ----------------------------
// GA4：商品ページクリック
// ----------------------------

document.addEventListener("click", function(event){

    const productLink =
        event.target.closest(".result-product-btn");

    if(!productLink){
        return;
    }

    trackGA4(
        "caterpy_fitting_product_click",
        {

            result_key:
                currentResultKey,

            product_name:
                productLink.dataset.productName || "",

            link_url:
                productLink.href

        }
    );

});

// ----------------------------
// キーを作る関数
// ----------------------------
function createResultKey(){

    const hole = answers[0].replace("穴","");

    const foot =
        answers[1].includes("甲が広い")
        ? "wide"
        : "normal";

    const size =
        answers[2] === "24.5cm以下"
        ? "small"
        : answers[2] === "25.0〜29.0cm"
        ? "medium"
        : "large";

    return `${hole}-${foot}-${size}`;

}
// ----------------------------
// リスタート
// ----------------------------

restartButton.addEventListener("click", () => {

    // 診断状態をリセット
    currentQuestion = 0;
    answers = [];

    currentResultKey = "";

    // 結果画面を非表示
    resultScreen.classList.remove("active");

    // スタート画面を表示
    startScreen.classList.add("active");

    // フィッティングシステムの先頭へ移動
    const fittingSection = document.getElementById("caterpy-fitting");

    if (fittingSection) {
        fittingSection.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }

});

const videoModal =
    document.getElementById("videoModal");

const videoModalClose =
    document.getElementById("videoModalClose");

const popupVideo =
    document.getElementById("popupVideo");

const popupVideoSource =
    popupVideo.querySelector("source");

const videoModalTitle =
    document.getElementById("videoModalTitle");


document.addEventListener("click", function(event){

    const trigger =
        event.target.closest(".product-video-trigger");

    if(!trigger){
        return;
    }

    // GA4：通し方動画クリック
    trackGA4(
        "caterpy_fitting_video_click",
        {

            result_key:
                currentResultKey,

            product_name:
                trigger.dataset.productName || "",

            video_title:
                trigger.dataset.title || ""

        }
    );

    const videoUrl =
        trigger.dataset.video;

    const videoTitle =
        trigger.dataset.title;

    popupVideoSource.src = videoUrl;

    videoModalTitle.textContent =
        videoTitle || "通し方動画";

    popupVideo.load();

    videoModal.classList.add("active");

    videoModal.setAttribute(
        "aria-hidden",
        "false"
    );

});


function closeVideoModal(){

    popupVideo.pause();

    popupVideo.currentTime = 0;

    popupVideoSource.src = "";

    popupVideo.load();

    videoModal.classList.remove("active");

    videoModal.setAttribute(
        "aria-hidden",
        "true"
    );

}


videoModalClose.addEventListener(
    "click",
    closeVideoModal
);


videoModal
    .querySelector(".video-modal__overlay")
    .addEventListener(
        "click",
        closeVideoModal
    );


document.addEventListener(
    "keydown",
    function(event){

        if(
            event.key === "Escape" &&
            videoModal.classList.contains("active")
        ){
            closeVideoModal();
        }

    }
);


// ----------------------------
// 詳細画像モーダル
// ----------------------------

const imageModal =
    document.getElementById("imageModal");

const imageModalClose =
    document.getElementById("imageModalClose");

const popupImage =
    document.getElementById("popupImage");

const imageModalTitle =
    document.getElementById("imageModalTitle");


// 画像サムネイルクリック
document.addEventListener("click", function(event){

    const trigger =
        event.target.closest(".product-image-trigger");

    if(!trigger){
        return;
    }

    const imageUrl =
        trigger.dataset.image;

    const imageTitle =
        trigger.dataset.title;

    popupImage.src = imageUrl;
    popupImage.alt = imageTitle || "詳細画像";

    imageModalTitle.textContent =
        imageTitle || "詳細画像";

    imageModal.classList.add("active");

    imageModal.setAttribute(
        "aria-hidden",
        "false"
    );

});


// モーダルを閉じる
function closeImageModal(){

    imageModal.classList.remove("active");

    imageModal.setAttribute(
        "aria-hidden",
        "true"
    );

    popupImage.src = "";
}


// ×ボタン
imageModalClose.addEventListener(
    "click",
    closeImageModal
);


// 背景クリック
imageModal
    .querySelector(".image-modal__overlay")
    .addEventListener(
        "click",
        closeImageModal
    );


// ESCキー
document.addEventListener(
    "keydown",
    function(event){

        if(
            event.key === "Escape" &&
            imageModal.classList.contains("active")
        ){
            closeImageModal();
        }

    }
);